import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { FiltersProvider } from '@data/providers';
import { FiltersRepository } from '@data/repositories';
import { TFiltersData } from '@domain/types';

export const reportFiltersResolver: ResolveFn<Promise<TFiltersData>> = async (
  _,
  __,
) => {
  const filtersRepository = inject(FiltersRepository);
  const filtersProvider = inject(FiltersProvider);

  const result = await filtersRepository.listFilters();

  filtersProvider.setFilials(result.filials);
  filtersProvider.setOperations(result.operations);

  return result;
};
